import React from 'react';
import SubscribeButton from '@/creditflowresearch/ui/common/components/SubscribeButton';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useBondsSubscription } from '@/creditflowresearch/application/Bonds/useBondsSubscription';
import { getLabelContent } from '../helpers';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import type { ButtonVariant, ButtonSize } from '@creditflowresearch/uilib/Button';

interface IInventoriesSubscribeButtonContainer {
  label?: string,
  isSubscribeAvailable: boolean,
  requiredPlan: UserPlanType,
  variant?: ButtonVariant,
  size?: ButtonSize,
}

const InventoriesSubscribeButtonContainer = (props: IInventoriesSubscribeButtonContainer) => {
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { isInventoriesFetching: isFetching, inventoriesData: { subscriptionStatus } } = useInventoryTableContext();
  const { subscriptionId, isSubscribed, subscribeBySSID } = useBondsSubscription(subscriptionStatus);

  return (
    <SubscribeButton
      { ...props }
      isFetching={ isFetching }
      subscriptionId={ subscriptionId }
      isSubscribed={ isSubscribed }
      label={ getLabelContent(subscriptionStatus.isSubscribed, currentAssetClass?.abbreviation) }
      subscribeBySSID={ subscribeBySSID }
    />
  );
};

export default InventoriesSubscribeButtonContainer;
